import { AWARD_CODES } from "../../../../../common/enums/award-codes";
import { useIncentiveViewConfig } from "../../../../../common/hooks/useIncentiveViewConfig";

const LS_PATH_VIEW_ID = "lsPathView";

/**
 * Determines if the current market/period is configured to use the path view
 * for Leadership Seminar based on incentiveViews config.
 */
export const useIsLSPathView = (): boolean => {
  const viewConfig = useIncentiveViewConfig(AWARD_CODES.LSI);
  return viewConfig?.viewId === LS_PATH_VIEW_ID;
};
